import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      display: 'flex',
      alignItems: 'center',
    },
    text: {
      color: colorsPalette.gray,
      fontWeight: 'bold',
      fontSize: 16,
      marginBottom: 0,
    },
    icon: {
      width: 16,
      height: 16,
      transform: 'rotate(270deg)',
      marginRight: SMALL_MARGIN,
    },
  }),
);

export default useStyles;
